import React from 'react'
import CivicLensBrand from '../../components/Shared/CivicLensBrand'
import { Text, InlineLink } from '@primer/react-brand'

// CHROMELESS AUTH SHELL (Cameron, 2026-09-13) — for pages whose only job is to
// get a person in: /sign-up, /sign-in and /sign-in/link.
//
// Unlike CenteredAuthLayout there is no marketing Header or Footer: the brand
// lockup centered above the content, and the legal links at the foot — the
// shape most product sign-in screens take. The marketing nav on a sign-in page
// offers ways out of the one thing the visitor came to do.

// The lens mark: a ring with a smaller disc caught off-center inside it, like
// light gathered by a lens. Civic Lens had no logo; this is drawn for these
// pages, in brand tokens rather than hex.

const BrandLockup = () => (
  <a
    href="/"
    aria-label="CivicLens home"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      textDecoration: 'none',
      color: 'var(--base-color-scale-gray-9)'
    }}
  >
    {/* One lockup, shared with the app and the marketing pages
        (components/Shared/CivicLensBrand.jsx) — this file used to draw its own
        copy of the mark and set the words itself. */}
    <CivicLensBrand markSize={38} fontSize={28} />
  </a>
)

const ChromelessAuthLayout = ({ children, maxWidth = 360 }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 24px 24px' }}>
        <div style={{ width: '100%', maxWidth: `${maxWidth}px` }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
            <BrandLockup />
          </div>
          {children}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', padding: '32px 24px' }}>
        <Text size="100" variant="muted"><InlineLink href="/terms">Terms of Service</InlineLink></Text>
        <Text size="100" variant="muted"><InlineLink href="/privacy">Privacy Policy</InlineLink></Text>
      </div>
    </div>
  )
}

export default ChromelessAuthLayout
